module.exports = __webpack_public_path__ + "static/media/logo_publicbank.ab7c9b78.svg";